import axios from "axios";
import { useEffect, useState } from "react";
import you from "../images/boy.png";
import bot from "../images/happy.png";
import LoadingDots from "./LoadingDots";
import image1 from "../images/delfrez chicken.png";
import image2 from "../images/Delfrez mutton.png";
import image3 from "../images/delfrez heart.png";
import image4 from "../images/delfrez energy.png";
import LastMenu2 from "./LastMenu2";

const ProcessedFoodItems = ({ categoryId }) => {
  const [PfItems, setPfItems] = useState([]);
  const [time] = useState(new Date().toLocaleTimeString());
  const [prodName, setProdName] = useState("");
  const [index, setIndex] = useState(0); // Single index to control left and right navigation
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setProdName(categoryId === 1 ? "Delfrez Meat" : "Delfrez Eggs");
  }, [categoryId]);

  useEffect(() => {
    axios
      .get(`https://poultry-chatbot-api.onrender.com/processed_foods/${categoryId}`)
      .then((response) => {
        if (response.data.food_items?.length > 0) {
          setPfItems(response.data.food_items);
        } else {
          alert("No Data found.");
        }
      })
      .catch((error) => {
        console.error("Error fetching food items:", error);
        alert("Failed to fetch food items.");
      })
      .finally(() => setLoading(false));
  }, [categoryId]);

  // Select images based on categoryId
  const images = categoryId === 1 ? [image1, image2] : [image3, image4];

  const moveLeft = () => {
    if (index > 0) setIndex(index - 1);
  };

  const moveRight = () => {
    if (index < PfItems.length - 1) setIndex(index + 1);
  };

  return (
    <>
      <div className="you-time">
        <img src={you} alt="boy" className="boy" />
        You {time}
      </div>

      <div className="you-message">
        <div className="frame2">{prodName}</div>
      </div>

      {loading ? (
        <div className="frame1">
          <LoadingDots />
        </div>
      ) : (
        <>
          <div className="chatbot">
            <img src={bot} alt="bot" className="bot" />
            <div className="chatbot-time">{time}</div>
          </div>

          <div className="frame1">
            {PfItems.length > 0 ? (
              <div className="carousel-container">
                <button onClick={moveLeft} className="nav-button">
                &#60;
                </button>

                {/* Display the food item with image and description */}
                <div className="food-item">
                  <b style={{fontSize: '18px'}}>{PfItems[index]?.food_name}</b><br></br>
                  <img
                    src={images[index % images.length]}
                    alt={PfItems[index]?.food_name}
                    className="carousel-image"
                  />
                  <div className="description">{PfItems[index]?.description}</div>
                </div>

                <button onClick={moveRight} className="nav-button">
                &#62;
                </button>
              </div>
            ) : (
              <p>No food items found.</p>
            )}
          </div>
          <LastMenu2 menu={1} />
        </>
      )}
      
    </>
  );
};

export default ProcessedFoodItems;
